import { render, staticRenderFns } from "./KYCScores.vue?vue&type=template&id=23eef08f&"
import script from "./KYCScores.vue?vue&type=script&lang=js&"
export * from "./KYCScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23eef08f')) {
      api.createRecord('23eef08f', component.options)
    } else {
      api.reload('23eef08f', component.options)
    }
    module.hot.accept("./KYCScores.vue?vue&type=template&id=23eef08f&", function () {
      api.rerender('23eef08f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/KYCScores.vue"
export default component.exports